module.exports = __webpack_public_path__ + "img/linkedin.63ed545a.svg";